import { render, staticRenderFns } from "./BlogDesc.vue?vue&type=template&id=08ce4168&scoped=true&"
import script from "./BlogDesc.vue?vue&type=script&lang=js&"
export * from "./BlogDesc.vue?vue&type=script&lang=js&"
import style0 from "./BlogDesc.vue?vue&type=style&index=0&id=08ce4168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ce4168",
  null
  
)

export default component.exports